import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const BroadcastFeedCard = ({ broadcast, onPlay, onSave, onShare }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    
    if (diffHours < 24) {
      return `${diffHours} ч. назад`;
    }
    
    const diffDays = Math.floor(diffHours / 24);
    if (diffDays < 7) {
      return `${diffDays} дн. назад`;
    }
    
    return date?.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  return (
    <div className="broadcast-feed-card bg-card rounded-lg border border-border overflow-hidden hover:shadow-soft transition-all duration-300">
      <div className="card-layout flex flex-col sm:flex-row gap-4 p-4">
        <div className="broadcast-artwork w-full sm:w-32 aspect-square sm:aspect-auto sm:h-32 rounded-lg overflow-hidden bg-muted flex-shrink-0 relative group cursor-pointer" onClick={() => onPlay(broadcast)}>
          <Image 
            src={broadcast?.artwork}
            alt={broadcast?.artworkAlt}
            className="w-full h-full object-cover"
          />
          <div className="play-overlay absolute inset-0 bg-background/60 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200">
            <div className="w-12 h-12 rounded-full bg-primary flex items-center justify-center">
              <Icon name="Play" size={24} color="var(--color-primary-foreground)" />
            </div>
          </div>
          {broadcast?.isNew && (
            <div className="new-badge absolute top-2 left-2 bg-accent text-accent-foreground px-2 py-0.5 rounded text-xs font-heading font-semibold">
              Новое
            </div>
          )}
        </div>

        <div className="broadcast-content flex-1 min-w-0">
          <div className="content-header mb-2">
            <h3 className="text-base font-heading font-semibold text-foreground mb-1 line-clamp-2 cursor-pointer hover:text-primary transition-colors" onClick={() => onPlay(broadcast)}>
              {broadcast?.title}
            </h3>
            <div className="flex items-center gap-2 mb-2">
              <div className="host-avatar w-6 h-6 rounded-full overflow-hidden bg-muted flex-shrink-0">
                <Image 
                  src={broadcast?.hostAvatar}
                  alt={broadcast?.hostAvatarAlt}
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="text-sm text-muted-foreground truncate">
                {broadcast?.hostName}
              </span>
            </div>
          </div>

          <p className="text-sm text-muted-foreground line-clamp-2 mb-3">
            {broadcast?.description}
          </p>

          <div className="content-footer flex items-center justify-between gap-4">
            <div className="broadcast-meta flex items-center gap-3 text-xs text-muted-foreground">
              <div className="flex items-center gap-1">
                <Icon name="Clock" size={14} color="currentColor" />
                <span className="font-mono">{broadcast?.duration}</span>
              </div>
              <div className="flex items-center gap-1">
                <Icon name="Calendar" size={14} color="currentColor" />
                <span>{formatDate(broadcast?.publishedAt)}</span>
              </div>
              <div className="flex items-center gap-1">
                <Icon name="Headphones" size={14} color="currentColor" />
                <span className="font-mono">{broadcast?.playCount}</span>
              </div>
            </div>

            <div className="action-buttons flex items-center gap-1">
              <button
                onClick={() => onSave(broadcast)}
                className="p-2 rounded-lg hover:bg-muted transition-colors duration-200"
                aria-label="Сохранить"
              >
                <Icon name="Bookmark" size={16} color="var(--color-foreground)" />
              </button>
              <button
                onClick={() => onShare(broadcast)}
                className="p-2 rounded-lg hover:bg-muted transition-colors duration-200"
                aria-label="Поделиться"
              >
                <Icon name="Share2" size={16} color="var(--color-foreground)" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BroadcastFeedCard;